import Swiper, { Navigation, Pagination, A11y, Keyboard } from 'swiper/core';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, A11y, Keyboard]);

class HeroHelper {
    constructor() {
    }

    heroScroller() {
        $('.form-container .collapse').on('shown.bs.collapse', function () {
            window.scrollTo(0,0);
            // Focus on now opened collapse
            var focusableEls = this.querySelectorAll('input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]');
            focusableEls = Array.prototype.slice.call(focusableEls);
            var firstFocusableEl = focusableEls[0];
            firstFocusableEl.focus();
        });
        $('#searchToggle').on('click', function() {
            $('#searchform').css('display', 'block');
            $('#heroSearch').focus();
        });
        $('#closeSearch').on('click', function() {
            $('#searchform').css('display', 'none');
            $('#searchToggle').focus();
        })
        const swiper = new Swiper('.swiper-container', {
            direction: 'vertical',
            slideToClickedSlide: true,
            slidesPerView: 5,
            centeredSlides: true,
            initialSlide: 2,
            a11y: true,
            keyboard: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              on: {
                slideChange: function() {
                    let previousSlide = document.getElementById('slide' + (this.previousIndex + 1));
                    let previousSlideButton = previousSlide.getElementsByClassName("swiper-go")[0];
                    previousSlideButton.disabled = true;

                    if (document.getElementById('tab_label'+(this.realIndex+1))) {
                        announce('Current selected topic: ' + document.getElementById('tab_label'+(this.realIndex+1)).innerHTML)
                    }

                    let activeSlide = document.getElementById('slide' + (this.realIndex + 1));
                    let activeSlideButton = activeSlide.getElementsByClassName("swiper-go")[0];
                    activeSlideButton.disabled = false;
                  }
              }
        });

        // // If a slide is focused on, navigate to that slide
        // const slides = document.getElementsByClassName('swiper-slide');
        // for (slide of slides) {
        //     slide.addEventListener('focus', (event) => {
        //         var index = event.target.id.substr(-1);
        //         swiper.slideTo(index);
        //     })
        // }
        

    }

    
}
export function announce(message) {
    const liveRegion = document.createElement('div');
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.classList.add('sr-only'); // Add a visually hidden class if needed
    liveRegion.textContent = message;
    document.body.appendChild(liveRegion);
  
    // Optional: Remove the element after a timeout
    setTimeout(() => {
      document.body.removeChild(liveRegion);
    }, 1000);
  }

window.app.add('hero', new HeroHelper());